import { useState } from "react";
import { CgClose } from "react-icons/cg";

const ComboBox = ({selectedValue = "", values, onChange }) => {
  const [query, setQuery] = useState(selectedValue || "");
  const [query2, setQuery2] = useState("");
  const [selected, setSelected] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const filteredValues = values.filter((item) =>
    item.toLowerCase().includes(query2.toLowerCase()) //upd
  );

  const handleSelect = (value) => {
    console.log("value selected", value);
    setSelected(value);
    setQuery(value);
    setIsOpen(false);
    if (onChange) onChange(value);
  };

  return (
    <div className="relative w-full">
      {/* Input de recherche */}
      <input
        type="text"
        className="py-2.5 sm:py-3 ps-4 border pe-9 block w-full outline-none border-gray-200 rounded-lg sm:text-sm focus:border-blue-500 focus:ring-blue-500"
        role="combobox"
        aria-expanded={isOpen}
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          setQuery2(e.target.value);
          setIsOpen(true);
        }}
        onClick={() => setIsOpen(!isOpen)}
        // onFocus={() => setIsOpen(true)}
        // onBlur={() => setIsOpen(false)}
        placeholder="Sélectionnez une option..."
      />
      
      {/* Boutons pour ouvrir/fermer la liste et reset */}
      <div className="absolute top-1/2 end-3 -translate-y-1/2 flex items-center gap-2">
        {selected && (
          <span className="cursor-pointer text-white rounded-full p-0.5 bg-gray-300" onClick={() => handleSelect("")}>
            <CgClose></CgClose>
          </span>
        )}
        <span className="cursor-pointer" onClick={() =>{
            setQuery2("")
            setIsOpen(!isOpen)
        } }>
                <svg className="size-3.5 text-gray-500" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="m7 15 5 5 5-5"></path>
   <path d="m7 9 5-5 5 5"></path>
       </svg>
        </span>
      </div>

      {/* Liste déroulante */}
      {isOpen && (
        <div className="absolute z-50 w-full max-h-60 p-1 bg-white border border-gray-200 rounded-lg shadow-md overflow-y-auto">
          {filteredValues.length > 0 ? (
            filteredValues.map((item, index) => (
              <div
                key={index}
                className={`cursor-pointer flex justify-between items-center py-2 px-4 text-sm text-gray-800 rounded-lg hover:bg-gray-100 ${
                  selected === item ? "bg-blue-100" : ""
                }`}
                onClick={() => handleSelect(item)}
              >
                {item}
                {selected === item && <span className="text-blue-500">✔</span>}
              </div>
            ))
          ) : (
            <div className="py-2 px-4 text-sm text-gray-500">Aucun résultat...</div>
          )}
        </div>
      )}
    </div>
  );
};

export default ComboBox;


// import { useState } from "react";

// const ComboBox = ({ values, onChange }) => {
//   const [query, setQuery] = useState("");
//   const [selected, setSelected] = useState(null);
//   const [isOpen, setIsOpen] = useState(false);

//   const filteredValues = values.filter((item) =>
//     item.toLowerCase().includes(query.toLowerCase())
//   );

//   const handleSelect = (value) => {
//     setSelected(value);
//     setQuery(value);
//     setIsOpen(false);
//     if (onChange) onChange(value);
//   };

//   return (
//     <div className="relative w-full">
//       {/* Input de recherche */}
//       <input
//         type="text"
//         className="py-2.5 sm:py-3 ps-4 pe-9 block w-full border outline-none border-gray-200 rounded-lg sm:text-sm focus:border-blue-500 focus:ring-blue-500"
//         role="combobox"
//         aria-expanded={isOpen}
//         value={query}
//         onChange={(e) => {
//           setQuery(e.target.value);
//           setIsOpen(true);
//         }}
//         onFocus={() => setIsOpen(true)}
//         onBlur={()=> setIsOpen(false)}
//         placeholder="Sélectionnez une option..."
//       />
      
//       {/* Bouton pour ouvrir/fermer la liste */}
//       <div
//         className="absolute top-1/2 end-3 -translate-y-1/2 cursor-pointer"
//         onClick={() => setIsOpen(!isOpen)}
//       >
//         <svg className="size-3.5 text-gray-500" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//           <path d="m7 15 5 5 5-5"></path>
//           <path d="m7 9 5-5 5 5"></path>
//         </svg>
//       </div>

//       {/* Liste déroulante */}
//       {isOpen && (
//         <div className="absolute z-50 w-full max-h-60 p-1 bg-white border border-gray-200 rounded-lg shadow-md overflow-y-auto">
//           {filteredValues.length > 0 ? (
//             filteredValues.map((item, index) => (
//               <div
//                 key={index}
//                 className={`cursor-pointer py-2 px-4 text-sm text-gray-800 rounded-lg hover:bg-gray-100 ${
//                   selected === item ? "bg-blue-100" : ""
//                 }`}
//                 onClick={() => handleSelect(item)}
//               >
//                 {item}
//               </div>
//             ))
//           ) : (
//             <div className="py-2 px-4 text-sm text-gray-500">Aucun résultat</div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default ComboBox;
